import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Tab,
  Tabs,
  IconButton,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { AdministrarMenuPresupuesto } from "./Menus/AdministrarMenuPresupuesto";
import { InformacionMenuPresupuesto } from "./Menus/InformacionMenuPresupuesto";
import { PracticasMenuPresupuesto } from "./Menus/PracticasMenuPresupuesto";
import { NotasMenuPresupuesto } from "./Menus/NotasMenuPresupuesto";
import { clearSolicitudYPracticas, putLiberarPresupuesto } from "../../../actions/autorizaciones/Autorizaciones";
import {
  AUTORIZACIONES_MENU_AUDITORIA,
  AUTORIZACIONES_PRESUPUESTOS_ESTADOS,
} from "../../../utils/constants";
import { AfiliadoMenu } from "../gestionAuditoria/Menus/AfiliadoMenu";
import { NoEncryptionSharp } from "@material-ui/icons";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export const ModalAuditarPresupuesto = (props, { type = 'currentUser' }) => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(
    AUTORIZACIONES_MENU_AUDITORIA.AFILIADO
  );

  const { presupuestoSeleccionado = {} } = useSelector(
    (state) => state.autorizaciones
  );

  const { open } = props;

  useEffect(() => {
    setSelectedTab(AUTORIZACIONES_MENU_AUDITORIA.AFILIADO);
  }, [open]);

  useEffect(() => {
    return () => {
      dispatch(clearSolicitudYPracticas());
    };
  }, []);

  const disabledAdministrar = /*presupuestoSeleccionado?.idEstadoPresupuesto ===
    AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO ||*/
    presupuestoSeleccionado?.idEstadoPresupuesto ===
    AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO || props.disabled

  // const disabled = presupuestoSeleccionado?.idEstadoPresupuesto ===
  //   AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO || 
  //       presupuestoSeleccionado?.idEstadoPresupuesto ===
  //   AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO;


  const { presupuestosTomadosUsuario } = useSelector((state) => state.autorizaciones);

  const handleLiberarPresupuesto = id => {
    dispatch(putLiberarPresupuesto(presupuestosTomadosUsuario[0]?.id, type, presupuestoSeleccionado?.idPresupuesto));

    props.closeModalHandler();
  }

  const disabled = true;

  console.log("presupuestoSeleccionado",presupuestoSeleccionado)
  return (
    <Dialog
      fullWidth
      maxWidth="md"
      //   maxWidth="lg"
      open={open}
      onClose={props.closeModalHandler}
    >
      
      <DialogTitle>
        {(presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE
        || presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS) && (
          <IconButton
          style={{ float: 'right', padding: 0, marginLeft: 15 }}
          color="inherit"
          onClick={handleLiberarPresupuesto}
        >
          <NoEncryptionSharp />
        </IconButton>
        )}
        
        <span style={{ float: "left" }}>
          Resumen del Presupuesto - N°{presupuestoSeleccionado?.idPresupuesto}
        </span>

      </DialogTitle>
      <DialogContent>
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            value={AUTORIZACIONES_MENU_AUDITORIA.AFILIADO}
            label="Afiliado"
            {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.AFILIADO)}
          />
          <Tab
            value={AUTORIZACIONES_MENU_AUDITORIA.INFORMACION}
            label="Información"
            {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.INFORMACION)}
          />
          <Tab
            value={AUTORIZACIONES_MENU_AUDITORIA.PRACTICAS}
            label={presupuestoSeleccionado?.soloMateriales ? "Materiales" : "Practicas"}
            {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.PRACTICAS)}
          />
          <Tab
            value={AUTORIZACIONES_MENU_AUDITORIA.NOTAS}
            label="Notas"
            {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.NOTAS)}
          />
          {!disabledAdministrar &&
            <Tab
              value={AUTORIZACIONES_MENU_AUDITORIA.ADMINISTRAR}
              label="Administrar"
              {...a11yProps(AUTORIZACIONES_MENU_AUDITORIA.ADMINISTRAR)}
            />
          }
        </Tabs>
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.AFILIADO}
        >
          <AfiliadoMenu afiliado={presupuestoSeleccionado?.afiliado} presupuestoSeleccionado={presupuestoSeleccionado}/>
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.INFORMACION}
        >
          <InformacionMenuPresupuesto
            disabled={disabled || 
              (presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE
                && presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS)}
            filtros={props.filtros}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.PRACTICAS}
        >
          <PracticasMenuPresupuesto
            disabled={/*disabled || */
              (presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
                || presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO)}
            desdeAuditar={true}
            onCloseModalAuditar={props.closeModalHandler}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.NOTAS}
        >
          <NotasMenuPresupuesto disabled={disabledAdministrar} />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={AUTORIZACIONES_MENU_AUDITORIA.ADMINISTRAR}
        >
          <AdministrarMenuPresupuesto closeModalAuditar={props.closeModalHandler} filtros={props.filtros}/>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};
